import React from "react";

interface CellProps extends React.HTMLAttributes<HTMLElement>{
  currency?: string | undefined
  value?: string | undefined
  columnname?: string | undefined
}

class Cell extends React.Component<CellProps> {

  render() {
    return (     
      <div        
        className={this.props.className}
        style={{
          alignContent:"flex-end"
        }}
      >
        <div
          style={{
            display:"flex",
            flexDirection:"row",
            width:(this.props.currency ? undefined : "max-content"),
            justifyContent:(this.props.currency ? "flex-end" : "flex-start"),            
            }}
          data-testid={this.props.columnname}
          >
          {this.props.children}
          {this.props.value}
          
        </div>
      </div>     
    );
  }
}

export default Cell;